import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IPersonAddress } from '../Models/IPersonAddress';
import { ITypedValidationResult } from '../Models/IValidationResult';

class personAddressService extends BaseApiService {
    public constructor() {
        super('PersonAddress/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByPersonAddressId(personAddressId: number, auth0Id: string): Promise<IPersonAddress> {
        return this.httpClient.get<IPersonAddress>(`GetByPersonAddressId?personAddressId=${personAddressId}&auth0Id=${auth0Id}`, personAddressService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    //public async getCounties(): Promise<ICounty[]> {
    public async getByPersonId(personId: number, auth0Id: string): Promise<IPersonAddress[]> {
        return this.httpClient.get<IPersonAddress[]>(`GetByPersonId?personId=${personId}&auth0Id=${auth0Id}`, personAddressService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async savePersonAddress(address: IPersonAddress, auth0Id: string) {
        console.log('Updating Person Address');
        this.httpClient.post<ITypedValidationResult<IPersonAddress>>(`SavePersonAddress?auth0Id=${auth0Id}`, address, personAddressService.config).catch(this.handleError.bind(this));
    }

    public async deletePersonAddress(personAddressId: number, auth0Id: string) {
        console.log('Deleting Person Address: ' + personAddressId);
        this.httpClient.delete(`DeletePersonAddress?personAddressId=${personAddressId}&auth0Id=${auth0Id}`,  personAddressService.config).catch(this.handleError.bind(this));
    }

}

export const PersonAddressService: personAddressService = new personAddressService();
export function createPersonAddress(): IPersonAddress {
    return {
        personAddressId: 0,
        personId: 0,
        addressTypeId: 0,
        addressTypeName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateId: 0,
        stateName: '',
        zipCode: '',
        modifiedBy: '',
        modifiedDate: ''
    };
}